import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router';
import { Routing } from '../core/Routing';
import StartPage from './Start/StartPage';
import DocumentsPage from './Documents/DocumentsPage';
import Loading from '@react_components/loading';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../core/Store';
import * as AppManager from '../reducers/ui/app';
import ReportPage from './Report/ReportPage';
import FaqPage from './Faq/FaqPage';
import FormPage from './Form/FormPage';
import FormSuccessPage from './FormSuccess/FormSuccessPage';
import PaymentSuccessPage from './PaymentSuccess/PaymentSuccessPage';

type State = {};

class MainRoutingComponent extends Component<PropsFromRedux, State> {
	state = {};

	componentDidUpdate(
		prevProps: Readonly<PropsFromRedux>,
		prevState: Readonly<State>,
		snapshot?: any
	): void {
		if (prevProps.appLoaded !== this.props.appLoaded) {
			document.body.style.overflow = this.props.appLoaded
				? 'initial'
				: 'hidden';
		}
	}

	render() {
		return (
			<Loading loading={!this.props.appLoaded}>
				<Switch>
					<Route exact path={Routing.main.start}>
						<StartPage />
					</Route>
					<Route path={Routing.main.reportDamage}>
						<ReportPage />
					</Route>
					<Route path={Routing.main.documents}>
						<DocumentsPage />
					</Route>
					<Route path={Routing.main.faq}>
						<FaqPage />
					</Route>
					<Route path={Routing.main.form}>
						<FormPage />
					</Route>
					<Route path={Routing.main.formSuccess}>
						<FormSuccessPage />
					</Route>
					<Route path={Routing.main.paymentSuccess}>
						<PaymentSuccessPage />
					</Route>
					<Redirect from="*" to={Routing.main.start} />
				</Switch>
			</Loading>
		);
	}
}

interface Own { }

const connector = connect(
	(state: AppState, own: Own) => ({
		appLoaded: AppManager.Selectors.getAppLoaded(state),
	}),
	(dispatch) => ({})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const MainRouting = connector(MainRoutingComponent);
export default MainRouting;
